import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactHtmlParser, {
    processNodes,
    convertNodeToElement,
    htmlparser2
} from "react-html-parser";

export const Modal = () => {
    const [modal, setmodal] = useState("open");
    const wasClosed = sessionStorage.getItem("modal");
    const [modalInfo, setModalInfo] = useState([]);

    const handleClose = () => {
        sessionStorage.setItem("modal", "close");
        setmodal("close");
    };

    useEffect(() => {
        const modalEl = document.querySelector(".modalBackdrop");
        if (modal == "open") {
            modalEl.style.display = "block";
        } else {
            modalEl.style.display = "none";
        }
        if (wasClosed != "close") {
            modalEl.style.display = "block";
        } else {
            modalEl.style.display = "none";
        }
    });

    useEffect(() => {
        fetch("/getModal")
            .then(res => res.json())
            .then(result => {
                setModalInfo(result);
            });
    }, []);

    return (
        <div className="modalBackdrop">
            <div className="modalScreen">
                <p className="title">
                    {modalInfo.titulo ? modalInfo.titulo : ""}
                </p>
                <ul>
                    <li>
                        <p>&nbsp;</p>
                    </li>
                    <li>
                        {ReactHtmlParser(
                            modalInfo.descripcion ? modalInfo.descripcion : ""
                        )}
                    </li>
                </ul>
                <button className="btn-modal" onClick={handleClose}>
                    ACEPTAR
                </button>
            </div>
        </div>
    );
};
